import { EventEmitter, Input, Output, Component, OnInit } from "@angular/core";
import { PipeFilter } from "./pipe";

@Component({
  selector: "input-filter",
  templateUrl: "./input-filter.component.html",
  standalone: false,
})
export class InputFilter implements OnInit {
  @Input() data: any[] = [];
  @Input() key: string = "company";
  @Input() slice: number;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() searchText: string;
  @Input() searchertext: string;
  @Output() itemSelectedEvent = new EventEmitter<any>();
  filteredItems: any[] = [];
  showList: boolean;

  itemSelected(item: any) {
    this.itemSelectedEvent.emit(item);
    this.showList = false;
    this.searchText = item[this.key];
  }

  constructor(private filter: PipeFilter) {}

  ngOnInit(): void {
    this.filteredItems = this.data;
  }

  onFocus() {
    this.apply(this.searchText);
    this.showList = true;
  }
  onEnter() {
    if (this.filteredItems.length > 0) this.itemSelected(this.filteredItems[0]);
    this.showList = false;
  }
  onBlur() {
    setTimeout(() => {
      this.showList = false;
    }, 200);
  }
  change(event) {
    this.apply(event.target.value);
    this.showList = true;
  }
  apply(search) {
    const filtered: any[] = this.filter.transform(this.data, this.key, search);
    this.filteredItems = this.slice ? filtered.slice(0, this.slice) : filtered;
  }
}
